import { Button, Form } from "antd";
import EditIcon from "../../../assets/icons/EditIcon";
import shebaLogo from "../../../assets/images/sheba-logo.svg";
import InfoItemTwo from "../../../components/common/sidebar/InfoItemTwo";
import EmployeeFileUpload from "../../../components/Employees/EmployeeFileUpload";
import SidebarLayout from "../../../layouts/SidebarLayout";

export default function Header() {
  const [form] = Form.useForm();
  const onFinish = (values: any) => {};
  return (
    <SidebarLayout title="Header">
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <div className="bg-white border border-extra-light p-6 max-w-[712px] rounded-md">
          <div
            className={`bg-[#F0F3F9] flex justify-between items-center border-b px-3 py-2.5 border-[#8897AE] font-medium rounded-t-md`}
          >
            <h4 className="text-display-body ">Pages Name/Title</h4>

            <div className="text-display-body ">Action</div>
          </div>

          <InfoItemTwo
            title="Pricing"
            children={
              <span className="text-[#4A72FF]">
                <EditIcon />
              </span>
            }
          />
          <InfoItemTwo
            title="Stories"
            children={
              <span className="text-[#4A72FF]">
                <EditIcon />
              </span>
            }
          />
          <InfoItemTwo
            title="Contact"
            rootClassName="rounded-b-md"
            children={
              <span className="text-[#4A72FF] ">
                <EditIcon />
              </span>
            }
          />

          <div
            className={`bg-[#F0F3F9] flex justify-between items-center border-b px-3 py-2.5 border-[#8897AE] font-medium rounded-t-md mt-6`}
          >
            <h4 className="text-display-body ">Header Button Title</h4>

            <div className="text-display-body ">Action</div>
          </div>

          <InfoItemTwo
            title="Pricing"
            children={
              <span className="text-[#4A72FF]">
                <EditIcon />
              </span>
            }
          />

          <InfoItemTwo
            title="Try it free"
            rootClassName="rounded-b-md"
            children={
              <span className="text-[#4A72FF] ">
                <EditIcon />
              </span>
            }
          />

          <div className="">
            <Form.Item
              name="nid_image_front"
              label="Logo"
              className="my-4 "
              valuePropName="fileUrl"
              rules={[
                {
                  required: true,
                  message: "Please upload NID photo",
                },
              ]}
            >
              <EmployeeFileUpload
                form={form}
                accept=".png, .jpg, .jpeg"
                name="nid_image_front"
                // onChange={(url) =>
                //   form.setFieldsValue({
                //     nid_image_front: url,
                //   })
                // }
              />
            </Form.Item>
            <div className="w-[120px] h-[84.22px]">
              <img src={shebaLogo} alt="" className="cover-full " />
            </div>
          </div>

          <Button className="middle-button mt-6" type="primary">
            Update
          </Button>
        </div>
      </Form>
    </SidebarLayout>
  );
}
